exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner[data-v-d4ea4a0c] {\n  height: var(--size-xxl);\n  background: var(--gray-800);\n  display: flex;\n  align-items: center;\n}\n@media screen and (min-width: 992px) {\n.banner[data-v-d4ea4a0c] {\n    margin-bottom: var(--size-lg);\n}\n}\n.banner.\\--margin-bottom[data-v-d4ea4a0c] {\n  margin-bottom: var(--size-md);\n}", ""]);

// exports
